import automationIcon from "assets/icons/2.svg";
import analyticsIcon from "assets/icons/1.svg";
import cloudIcon from "assets/icons/3.svg";
import SecurityIcon from "@mui/icons-material/Security";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SyncIcon from "@mui/icons-material/Sync";
import AssessmentIcon from "@mui/icons-material/Assessment";
import FeedbackIcon from "@mui/icons-material/Feedback";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";

// Convert to JSX elements
const securityIcon = <SecurityIcon />;
const accessIcon = <AdminPanelSettingsIcon />;
const syncIcon = <SyncIcon />;
const reportsIcon = <AssessmentIcon />;
const responseIcon = <FeedbackIcon />;
const auditIcon = <VerifiedUserIcon />;

const features = [
  // Existing Features…
  {
    title: "Automated Workflows",
    description: "Streamline your tasks with smart automation.",
    icon: automationIcon,
  },
  {
    title: "Real-Time Analytics",
    description: "Gain insights with intuitive dashboards.",
    icon: analyticsIcon,
  },
  {
    title: "Secure Cloud Access",
    description: "Access your data securely from anywhere.",
    icon: cloudIcon,
  },

  // New Features
  {
    title: "AI-Powered Security",
    description: "Protect infrastructure with intelligent threat detection.",
    icon: securityIcon,
  },
  {
    title: "Role-Based Access",
    description: "Customize permissions for teams and projects.",
    icon: accessIcon,
  },
  {
    title: "Multi-Platform Sync",
    description: "Keep your data updated across devices in real time.",
    icon: syncIcon,
  },
  {
    title: "Custom Reporting",
    description: "Tailor metrics and KPIs to your workflow.",
    icon: reportsIcon,
  },
  {
    title: "Incident Response Automation",
    description: "React to threats with precision and speed.",
    icon: responseIcon,
  },
  {
    title: "Audit Trails",
    description: "Track system changes and user actions transparently.",
    icon: auditIcon,
  },
];

export default features;
